import DesignerRightPanel from './DesignerRightPanel';

export default DesignerRightPanel;
